// Serviço da IA Sistemas (backend nova_ia_sistemas - Claude Haiku 4.5)
// Usa o MESMO login do painel: o JWT admin salvo no localStorage é aceito
// pelo backend da IA (validado com a SecretKey + tabela admins).
import axios from "axios";

const IA_BASE_URL =
  process.env.REACT_APP_IA_API_URL || "http://localhost:3001";

const iaApi = axios.create({ baseURL: IA_BASE_URL });

iaApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminAccessToken");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

export const iaService = {
  // ---------- Dashboard ----------
  getDashboardStats: async () => {
    const { data } = await iaApi.get("/api/admin/stats/dashboard");
    return data;
  },

  // ---------- Conversas (leads e clientes) ----------
  getChats: async (
    platform,
    { page = 1, limit = 50, search = "", tema, reclamacao, sentimento } = {}
  ) => {
    const { data } = await iaApi.get("/api/admin/chats", {
      params: {
        platform,
        page,
        limit,
        search: search || undefined,
        tema,
        sentimento,
        reclamacao: reclamacao ? "true" : undefined,
      },
    });
    return data; // { data, pagination }
  },

  getChatMessages: async (chatId, { page = 1, limit = 200 } = {}) => {
    const { data } = await iaApi.get(`/api/admin/chats/${chatId}/messages`, {
      params: { page, limit },
    });
    return data; // { data, pagination }
  },

  /** status: "active" | "blocked" */
  setChatStatus: async (chatId, status) => {
    const { data } = await iaApi.patch(`/api/admin/chats/${chatId}/status`, {
      status,
    });
    return data;
  },

  // ---------- Tickets de suporte ----------
  getTickets: async ({ page = 1, limit = 15, status, emergency_level, search } = {}) => {
    const { data } = await iaApi.get("/api/admin/tickets", {
      params: {
        page,
        limit,
        status: status || undefined,
        emergency_level: emergency_level || undefined,
        search: search || undefined,
      },
    });
    return data; // { data, pagination }
  },

  /** status: 1 Pendente | 2 Em análise | 3 Resolvido | 4 Cancelado */
  setTicketStatus: async (ticketId, status) => {
    const { data } = await iaApi.patch(`/api/admin/tickets/${ticketId}/status`, {
      status,
    });
    return data;
  },

  // ---------- IA interna de relatórios ----------
  getInternalChats: async () => {
    const { data } = await iaApi.get("/api/admin/internal-chats");
    return data;
  },

  getInternalChatMessages: async (chatId) => {
    const { data } = await iaApi.get(
      `/api/admin/internal-chats/${chatId}/messages`
    );
    return data;
  },

  askInternalReport: async (question, chatId = null) => {
    const { data } = await iaApi.post("/api/admin/internal-report", {
      question,
      chatId: chatId || undefined,
    });
    return data; // { response, chat_id }
  },
};
